// arpy — product pages: payment logos under the add-to-cart button, and on phones a buy bar
// that stays on screen while the main button is out of view. Progressive enhancement, idempotent.
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function start() {
    var btn = document.querySelector('.arpy-add-button');
    if (!btn) return;

    // payment logos: the theme renders the store's enabled payment types into a <template>
    function addLogos() {
      if (document.querySelector('.arpy-pay')) return;
      var tpl = document.getElementById('arpy-pay-icons');
      if (!tpl || !tpl.content || !tpl.content.children.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'arpy-pay';
      wrap.setAttribute('aria-label', 'accepted payment methods');
      wrap.appendChild(tpl.content.cloneNode(true));
      btn.insertAdjacentElement('afterend', wrap);
    }
    // wait for the trust block so the logos always sit between the button and the trust rows
    var tries = 0;
    var timer = setInterval(function () {
      if (document.querySelector('.arpy-trust') || ++tries > 20) { clearInterval(timer); addLogos(); }
    }, 150);

    // buy bar
    if (document.querySelector('.arpy-buybar')) return;
    var title = document.querySelector('.arpy-product-title');
    var price = document.querySelector('.arpy-price-pill');
    var root = document.querySelector('.arpy-product');
    var bar = document.createElement('div');
    bar.className = 'arpy-buybar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'buy this product');

    var info = document.createElement('div');
    info.className = 'arpy-buybar-info';
    var name = document.createElement('strong');
    name.textContent = title ? title.textContent.trim() : document.title;
    var cost = document.createElement('span');
    cost.textContent = price ? price.textContent.trim() : '';
    info.appendChild(name); info.appendChild(cost);

    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'arpy-buybar-btn';
    go.textContent = btn.disabled ? 'sold out' : 'add to cart';
    go.disabled = btn.disabled;
    go.addEventListener('click', function () { if (!btn.disabled) btn.click(); });

    bar.appendChild(info); bar.appendChild(go);
    // the bar's button takes the colour of the page's own add-to-cart outline (the product colour;
    // green on the core four), with white text when that colour is dark
    var rgb = (getComputedStyle(btn).borderTopColor.match(/[\d.]+/g) || []).map(Number);
    if (rgb.length >= 3 && (rgb.length < 4 || rgb[3] > 0.3)) {
      bar.style.setProperty('--buybar-accent', 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')');
      var lin = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
      var lum = 0.2126 * lin(rgb[0]) + 0.7152 * lin(rgb[1]) + 0.0722 * lin(rgb[2]);
      if (lum < 0.3) go.style.color = '#fff';
    }
    document.body.appendChild(bar);

    function set(on) {
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('arpy-buybar-on', on);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { set(!entries[0].isIntersecting); }, { threshold: 0.6 }).observe(btn);
    } else {
      set(true);
    }
  }

  // core four: its first photo is square and shows all four bottles. The photo frame is taller than it is
  // wide, so filling the frame cut the outer two bottles off. Wide photos are shown whole here, and the
  // space above and below takes the photo's own edge colours so no band is visible.
  function fitWidePhotos() {
    if (!/\/products\/core-four/.test(location.pathname)) return;
    var stage = document.querySelector('.arpy-product-image');
    if (!stage) return;
    var cache = {};
    function read(url, cb) {
      if (cache[url]) return cb(cache[url]);
      var img = new Image();
      img.onload = function () {
        var info = { ar: img.naturalWidth / img.naturalHeight, top: null, bottom: null };
        try {
          var c = document.createElement('canvas'); c.width = 24; c.height = 24;
          var x = c.getContext('2d'); x.drawImage(img, 0, 0, 24, 24);
          var px = function (cx, cy) { var d = x.getImageData(cx, cy, 1, 1).data; return 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')'; };
          info.top = [px(0, 0), px(12, 0), px(23, 0)];
          info.bottom = [px(0, 23), px(12, 23), px(23, 23)];
        } catch (e) {}
        cache[url] = info; cb(info);
      };
      img.onerror = function () { cb(null); };
      img.src = url;
    }
    function apply() {
      var bg = stage.style.backgroundImage || '';
      if (bg.indexOf('linear-gradient(90deg') >= 0) return; // already fitted by this script
      var m = bg.match(/url\(["']?([^"')]+)["']?\)/);
      if (!m) return;
      var url = m[1];
      read(url, function (info) {
        var now = stage.style.backgroundImage || '';
        if (now.indexOf(url) < 0 || now.indexOf('linear-gradient(90deg') >= 0) return;
        var frame = stage.clientWidth / Math.max(1, stage.clientHeight);
        if (!info || !(info.ar > frame * 1.15)) {
          stage.style.backgroundSize = ''; stage.style.backgroundPosition = ''; stage.style.backgroundRepeat = '';
          return;
        }
        var t = info.top || ['#FAE4CA', '#FAE4CA', '#FAE4CA'], b = info.bottom || t;
        stage.style.backgroundImage = "url('" + url + "'), " +
          'linear-gradient(90deg, ' + t.join(', ') + '), linear-gradient(90deg, ' + b.join(', ') + ')';
        stage.style.backgroundSize = 'contain, 100% 51%, 100% 51%';
        stage.style.backgroundPosition = 'center, top, bottom';
        stage.style.backgroundRepeat = 'no-repeat';
      });
    }
    new MutationObserver(apply).observe(stage, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', function () {
      var m = (stage.style.backgroundImage || '').match(/url\(["']?([^"')]+)["']?\)/);
      if (m) { stage.style.backgroundImage = "url('" + m[1] + "')"; }
    });
    apply();
  }

  // ad visitors who searched for "ghk-cu": the ad's address carries the keyword (kw=...) or ghk=1.
  // The bottle says ghk-cu but the page text says copper peptide, so say plainly that they are the same thing.
  function ghkNote() {
    if (!/\/products\/copper-peptide-face-serum/.test(location.pathname)) return;
    var q = '';
    try { q = decodeURIComponent(location.search).toLowerCase(); } catch (e) { q = location.search.toLowerCase(); }
    if (!/[?&]ghk=1\b/.test(q) && !/[?&]kw=[^&]*ghk/.test(q)) return;
    var sub = document.querySelector('.arpy-product-subtitle');
    if (!sub || document.querySelector('.arpy-ghk-note')) return;
    var p = document.createElement('p');
    p.className = 'arpy-ghk-note';
    p.textContent = 'looking for ghk-cu? this is it. ghk-cu is the common name for copper tripeptide-1, the copper peptide in this serum.';
    sub.insertAdjacentElement('afterend', p);
  }

  function boot() { start(); fitWidePhotos(); ghkNote(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
